import __vue from 'vue'
import './filters'
window.Vue = __vue;


import axios from "axios";

Vue.prototype.$http = axios;

Vue.config.ignoredElements = [
    'item'
]

new Vue({
    data: {
        loading: false,
        photoError: null,
        descriptionError: null,
        showDescription: false,
        description: window.description,
        file: null,

        errors: [],
        reportForm: {
            name: '',
            email: '',
            reason: '',
            further_details: '',
            terms: false,
            recaptcha_response: '',
        },
        reportRecaptchaId: null,
        reportUrl: null,
        user: window.user,
    },
    methods: {
        handleFileUpload(event) {
            this.file = this.$refs.file.files[0];
        },
        saveCoverPhoto: function () {
            this.loading = true;
            this.photoError = null;

            let formData = new FormData();
            formData.append('cover-photo-upload', this.file);

            axios.post('/api/tradesperson/'+window.tradesperson+'/cover-photo',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(response => {
                if (response.data.error) {
                    this.loading = false;
                    this.photoError = response.data.error;
                } else {
                    window.location.reload();
                }
            });
        },
        saveDescription: function () {
            this.loading = true;
            this.descriptionError = null;

            axios({
                method: 'post',
                data: {description: this.description},
                url: '/api/tradesperson/'+window.tradesperson+'/description'
            }).then(response => {
                if (response.data.error) {
                    this.loading = false;
                    this.descriptionError = response.data.error;
                } else {
                    window.location.reload();
                }
            });
        },
        deleteImage: function (id) {
            if (confirm("Are you sure?")) {
                this.loading = true;

                axios({
                    method: 'post',
                    data: {id: id},
                    url: '/api/tradesperson/'+window.tradesperson+'/gallery-images/'+id+'/delete'
                }).then(response => {
                    if (response.data.error) {
                        this.loading = false;
                    } else {
                        window.location.reload();
                    }
                });
            }
        },
        viewProfilePhoto: function (url) {
            window.open(
                url,
                '_blank' // <- This is what makes it open in a new window.
            );
        },

        launchReportPopup(id) {
            this.reportUrl = `/api/reviews/${id}/report`;
            if (this.user) {
                this.reportForm.name = this.user.fname + ' ' + this.user.sname;
                this.reportForm.email = this.user.email;
            }
            window.showMjqPopup('report-review');
            this.renderReportRecaptcha();
        },
        renderReportRecaptcha() {
            if (this.reportRecaptchaId !== null || !window.grecaptcha) {
                return;
            }

            window.grecaptcha.ready(() => {
                if (this.reportRecaptchaId !== null) {
                    return;
                }

                this.reportRecaptchaId = window.grecaptcha.render(this.$refs.reportRecaptcha, {
                    sitekey: this.$refs.reportRecaptcha.dataset.sitekey,
                    callback: token => {
                        this.reportForm.recaptcha_response = token;
                    },
                    'expired-callback': () => {
                        this.reportForm.recaptcha_response = '';
                    },
                });
            });
        },
        resetReportRecaptcha() {
            this.reportForm.recaptcha_response = '';

            if (this.reportRecaptchaId !== null) {
                window.grecaptcha.reset(this.reportRecaptchaId);
            }
        },
        submitReport() {
            this.loading = true;
            this.errors = [];

            axios.post(this.reportUrl, this.reportForm)
              .then(response => {
                  if (response.data.errors) {
                      this.errors = response.data.errors;
                  } else {
                      this.closePopup();
                      setTimeout(() => {
                          window.showMjqPopup('reported');
                      }, 500);
                  }
              })
              .catch(error => {
                  if (error && error.response.status === 429) {
                      this.errors = error.response.data.errors;
                  } else {
                      this.errors = ['Something went wrong. Please try again.'];
                  }
              })
              .finally(() => {
                  this.loading = false;
                  this.resetReportRecaptcha();
              });
        },
        closePopup() {
            this.resetReportForm();

            $('.main-popup-bg,.popup-quoteform-cover,.main-popup-container').fadeOut(200);
            $('.main-popup-container').css('transform', 'scale(0,0)');
            $('body').css('overflow', 'visible');
            $('html').css('overflow', 'visible');
        },
        resetReportForm() {
            this.errors = [];
            this.loading = false;

            this.reportForm = {
                name: '',
                email: '',
                reason: '',
                further_details: '',
                terms: false,
                recaptcha_response: '',
            };

            this.resetReportRecaptcha();
        },
        redirectTo(url) {
            window.location.href = url;
        },
        first(obj) {
            return obj[Object.keys(obj)[0]];
        },
    }
}).$mount('#profile');

$(document).ready(function() {
    $('.upload-picture').click(function() {
        window.showMjqPopup('uploadPicture');
    });
});